var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import UserXSvg from './user-x.icon.svg';
export const UserXIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: UserXSvg }));
_react_refresh_temp_1 = UserXIcon;
$RefreshReg$(_react_refresh_temp_1, "UserXIcon");
